import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { WalletCbpayRatesService } from '../../services/wallet-cbpay-rates.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ParameterService } from 'src/app/dashboard/services/parameter.service';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-cbpay-view-wallet-transactions',
  templateUrl: './cbpay-view-wallet-transactions.component.html',
  styleUrls: ['./cbpay-view-wallet-transactions.component.sass'],
})
export class CbpayViewWalletTransactionsComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  showData(data: any): void {
    const isMobile = window.innerWidth < 768;
    const info = data?.infoUsuario || {};
    const infoBanco = data?.infoBanco || {};

    const buildRow = (label: string, value: any, color?: string) => {
      if (!value && value !== 0) return '';
      const valStyle = color ? `color: ${color}; font-weight: 700;` : 'color: #111827; font-weight: 500;';
      return `
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid #f3f4f6;">
          <span style="color: #6b7280; font-size: 0.8rem;">${label}</span>
          <span style="font-size: 0.85rem; ${valStyle} text-align: right; max-width: 60%; word-break: break-all;">${value}</span>
        </div>`;
    };

    const htmlContent = `
      <div style="text-align: left;">
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 16px; margin-bottom: 12px;">
          <div style="font-size: 0.75rem; color: #1e5a3f; font-weight: 600; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.05em;">
            Información del Usuario
          </div>
          ${buildRow('Usuario', info.name)}
          ${buildRow('User ID', info.userId)}
          ${buildRow('Documento', info.idNumberDestino)}
          ${buildRow('Monto', info.amount, '#1e5a3f')}
          ${buildRow('Email', info.email)}
          ${buildRow('Teléfono', info.phone)}
        </div>

        ${Object.keys(infoBanco).length > 0 ? `
        <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; padding: 16px; margin-bottom: 12px;">
          <div style="font-size: 0.75rem; color: #1e40af; font-weight: 600; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.05em;">
            Información Bancaria
          </div>
          ${buildRow('Banco', infoBanco.bankName)}
          ${buildRow('Cuenta', infoBanco.accountNumber)}
          ${buildRow('Tipo', infoBanco.accountType)}
          ${buildRow('Titular', infoBanco.holderName)}
          ${buildRow('Documento', infoBanco.holderId)}
          ${buildRow('Teléfono', infoBanco.phoneNumber)}
        </div>` : ''}

        <details style="margin-top: 8px;">
          <summary style="cursor: pointer; font-size: 0.8rem; color: #6b7280; padding: 8px; background: #f9fafb; border-radius: 8px; user-select: none;">
            Ver JSON completo
          </summary>
          <pre style="
            text-align: left;
            background: #1e293b;
            color: #e2e8f0;
            padding: 12px;
            border-radius: 8px;
            white-space: pre-wrap;
            font-size: ${isMobile ? '11px' : '12px'};
            font-family: 'Courier New', Courier, monospace;
            overflow-x: auto;
            max-height: 250px;
            margin-top: 8px;">${this.formatJson(data)}</pre>
        </details>
      </div>`;

    Swal.fire({
      title: '',
      html: htmlContent,
      showCloseButton: true,
      confirmButtonText: 'Cerrar',
      confirmButtonColor: '#1C593D',
      width: isMobile ? '95vw' : '550px',
      customClass: {
        popup: 'swal2-overflow',
      },
    });
  }

  transactions: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  page: number = 1;
  limit: number = 10;
  totalPages: number = 0;
  total: number = 0;
  idNumberDestination: string = '';
  from: string = '';
  to: string = '';
  toDate: Date = new Date();
  selectedData: any = null;
  transaction: any;
  errorMessage: string = '';
  expandedCardId: number | null = null;

  displayedColumns = [
    'transaction_id',
    'tipo',
    'idUsuario',
    'transactionStatus',
    'beneficiario',
    'monto',
    'documento',
    'fecha',
    'status',
    'mensaje',
    'data',
  ];

  constructor(
    private datePipe: DatePipe,
    private spinner: SpinnerService,
    private cbpayService: WalletCbpayRatesService,
    private dialog: MatDialog,
    private parameterService: ParameterService,
    private auth: CognitoService,
    private cdRef: ChangeDetectorRef,
  ) {}
  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  async ngOnInit() {
    await this.loadTransactions();
    const today = new Date();
    this.to = this.formatDateToString(today, 'to');
  }

  async loadTransactions() {
    try {
      this.errorMessage = ''; // Limpia el mensaje de error antes de intentar cargar

      const formattedFrom = this.from
        ? this.formatDateToString(new Date(this.from), 'from')
        : undefined;
      const formattedTo = this.to
        ? this.formatDateToString(new Date(this.to), 'to')
        : undefined;

      const response = await this.cbpayService.getTransactionsCBPay(
        this.page,
        this.limit,
        this.idNumberDestination,
        formattedFrom,
        formattedTo,
      );

      // ✅ Verifica si la respuesta tiene datos
      if (response.transactions.length === 0) {
        this.errorMessage =
          'No se encontraron transacciones para los filtros seleccionados.';
        this.dataSource.data = [];
        this.total = 0;
        this.totalPages = 0;
        return;
      }

      // ✅ Actualiza las variables con la respuesta del servicio
      this.total = response.total;
      this.transactions = response.transactions;
      this.totalPages = response.totalPages;
      this.dataSource.data = this.transactions;

      // ✅ Forzar la detección de cambios para que el paginador actualice sus valores
      this.cdRef.detectChanges();
    } catch (error) {
      this.errorMessage =
        'Error al cargar las transacciones. Intente nuevamente más tarde.';
    }
  }

  changePage(event: PageEvent) {
    const spinnerRef = this.spinner.start();
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    this.loadTransactions();
    this.spinner.stop(spinnerRef);
  }

  changeLimit(newLimit: number) {
    this.limit = newLimit;
    this.page = 1;
    this.loadTransactions();
  }

  async reload(): Promise<void> {
    this.page = 1;
    this.loadTransactions();
  }

  async applyFilters() {
    this.page = 1;
    this.loadTransactions();
  }

  formatDateToString(date: Date, type: 'from' | 'to'): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    const time = type === 'from' ? '00:00:00' : '23:59:59';

    return `${year}-${month}-${day} ${time}`;
  }

  toggleCard(id: number): void {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  getStatusBg(estado: string | undefined): string {
    if (!estado) return '#9ca3af';
    const s = estado.toLowerCase();
    if (s.includes('completada') || s.includes('aprobada') || s.includes('exitosa')) return '#16a34a';
    if (s.includes('pendiente') || s.includes('proceso')) return '#f59e0b';
    if (s.includes('rechazada') || s.includes('error') || s.includes('fallida')) return '#dc2626';
    return '#6b7280';
  }

  getTransactionType(tipo: string): string {
    const typesMap: { [key: string]: string } = {
      paymentCBPayMovilPayWallet: 'Pago Móvil',
      paymentCBPayTransferDirectWallet: 'Transferencia Directa',
    };
    return typesMap[tipo] || tipo;
  }

  formatJson(json: any): string {
    const jsonString = JSON.stringify(json, null, 2);
    return jsonString.replace(
      /("(.*?)")(: )?("[^"]*"|\d+|true|false|null)/g,
      (_match, key, _keyName, colon, value) => {
        return `<span style="color: #f78c6c;">${key}</span>${colon ? '<span style="color: white;">:</span>' : ''} <span style="color: #89ddff;">${value}</span>`;
      },
    );
  }

  async exportarExcel(): Promise<void> {
    try {
      const formattedFrom = this.from
        ? this.formatDateToString(new Date(this.from), 'from')
        : undefined;
      const formattedTo = this.to
        ? this.formatDateToString(new Date(this.to), 'to')
        : undefined;

      await this.cbpayService.downloadExcelCBPay(
        this.idNumberDestination,
        formattedFrom,
        formattedTo,
      );
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error al exportar',
        text: 'No se pudo descargar el archivo Excel.',
      });
    }
  }
}
